////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const translationsManager = {
	getListTranslations: (filters = {}, queryParam = { page: '0', size: '250' }) => ({
		type: ActionsTypes.GET_LIST_TRANSLATIONS,
		payload: { filters, queryParam },
	}),
	getListTranslationsSuccess: (data) => ({
		type: ActionsTypes.GET_LIST_TRANSLATIONS_SUCCESS,
		payload: {
			data,
		},
	}),
	getListTranslationsFailure: (error) => ({
		type: ActionsTypes.GET_LIST_TRANSLATIONS_FAILURE,
		payload: {
			error,
		},
	}),
	setTranslation: (id, data) => ({
		type: ActionsTypes.SET_TRANSLATION,
		payload: {
			id,
			data,
		},
	}),
	setTranslationSuccess: (data, idLanguage) => ({
		type: ActionsTypes.SET_TRANSLATION_SUCCESS,
		payload: {
			data,
			idLanguage,
		},
	}),
	setTranslationFailure: (error) => ({
		type: ActionsTypes.SET_TRANSLATION_FAILURE,
		payload: {
			error,
		},
	}),
}

export default translationsManager
